import BasePagingType from 'owa-service/lib/contract/BasePagingType';
import findItemOperation from 'owa-service/lib/operation/findItemOperation';
import findItemRequest from 'owa-service/lib/factory/findItemRequest';
import FindItemRequest from 'owa-service/lib/contract/FindItemRequest';
import FindItemResponseMessage from 'owa-service/lib/contract/FindItemResponseMessage';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import FolderId from 'owa-service/lib/contract/FolderId';
import folderId from 'owa-service/lib/factory/folderId';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import SortResults from 'owa-service/lib/contract/SortResults';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

interface FindItemParams {
    currentFolderId: string;
    paging: BasePagingType;
    focusedViewFilter: FocusedViewFilter;
    viewFilter: ViewFilter;
    sortOrder: SortResults[];
}

function configureRequestBody({
    currentFolderId,
    paging,
    focusedViewFilter,
    viewFilter,
    sortOrder,
}: FindItemParams): FindItemRequest {
    const itemShape = itemResponseShape({ BaseShape: 'IdOnly' });

    const parentFolderId = folderId({ Id: currentFolderId } as FolderId);

    return findItemRequest({
        ParentFolderIds: [parentFolderId],
        ItemShape: itemShape,
        ShapeName: 'MailListItem',
        Traversal: 'Shallow',
        Paging: paging,
        FocusedViewFilter: focusedViewFilter,
        ViewFilter: viewFilter,
        SortOrder: sortOrder,
    });
}

export function findItem(findItemParams: FindItemParams): Promise<FindItemResponseMessage> {
    const requestBody = configureRequestBody(findItemParams);

    return findItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => response.Body.ResponseMessages.Items[0]);
}
